import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconRecKeyframe: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"rec-keyframe, rhombus"} maskId="square-filled-radius-0-stroke-1-IconRecKeyframe"><path fillRule="evenodd" clipRule="evenodd" d="M1.29297 12L12.0001 1.29297L22.7072 12L12.0001 22.7072L1.29297 12ZM8.5 12C8.5 10.067 10.067 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconRecKeyframe;
